import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_card",
  "use": "icon-icon_card-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-icon_card\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h22v22H0z\" /><path d=\"M21.021 6.528v-1.5c0-1.378-.929-2.5-2.084-2.5H3.105c-1.144 0-2.084 1.122-2.084 2.5v1.5m0 1.989v8.51c0 1.378.929 2.5 2.084 2.5h15.832c1.144 0 2.084-1.122 2.084-2.5v-8.51h-20Zm16.026 8.51h-4.038l.923-3.005h4.005l-.89 3.006Z\" fill=\"#B4BAC6\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol